import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Environment } from '@core/services/common';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
@Injectable()
export class HttpMockInterceptorService implements HttpInterceptor {
  private static mocksRequestProtocol = 'demo://';
  private static mocksBasePath = 'assets/mocks';
  private static maxMockRequestDelay = 2000;

  constructor() {}

  static setMaxMockRequestDelay(delayMs: number) {
    HttpMockInterceptorService.maxMockRequestDelay = delayMs;
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isHttpRequest = request.url.startsWith('http');
    const isDemoRequest = request.url.startsWith(
      HttpMockInterceptorService.mocksRequestProtocol
    );
    const isMockableRequest =
      (isHttpRequest || isDemoRequest) &&
      Environment.config().envName === 'demo';

    if (!isMockableRequest) {
      return next.handle(request);
    }

    // Mocking HTTP response
    if (this.shouldHaveMockResponse(request)) {
      const mockPath = this.getMockPath(request);
      const delayRequestMs = this.getMockRequestDelay();
      return next
        .handle(this.buildMockRequest(mockPath))
        .pipe(delay(delayRequestMs));
    }
    return of(new HttpResponse({ status: 200 }));
  }

  private getMockPath(request: HttpRequest<any>) {
    const mocksBaseUrl = `${HttpMockInterceptorService.mocksRequestProtocol}${HttpMockInterceptorService.mocksBasePath}`;
    const urlRegex = new RegExp(`^${mocksBaseUrl}/(.[^/]*)/(.[^?]*)`);
    const matchRoute = urlRegex.exec(request.url);
    if (matchRoute && matchRoute[1] && matchRoute[2]) {
      const apiName = matchRoute[1];
      const urlPath = matchRoute[2];
      const jsonFilename = this.getMockJSONFilename(apiName, urlPath);
      return `${HttpMockInterceptorService.mocksBasePath}/${apiName}/${jsonFilename}.json`;
    }
    return null;
  }

  private shouldHaveMockResponse(request: HttpRequest<any>) {
    return request.method === 'GET' || this.isLoginRequest(request);
  }

  private isLoginRequest(req: HttpRequest<any>) {
    return req.url.indexOf('jwt') >= 0;
  }

  private buildMockRequest(mockUrlPath: string) {
    return new HttpRequest('GET', mockUrlPath);
  }

  private getMockJSONFilename(apiName: string, urlPath: string) {
    if (apiName === 'mmobile') {
      if (urlPath.indexOf('jwt/login') >= 0) {
        return 'jwt';
      }
      if (urlPath.indexOf('config/mets/1.0-DEMO') >= 0) {
        return 'config';
      }
      const path = urlPath.replace('services/j/mets/1.0-DEMO/', '');
      const urlRegex = new RegExp(`^(.[^/]*)\/(.[^?]*)`);
      const matchRoute = urlRegex.exec(path);
      if (matchRoute && matchRoute[1] && matchRoute[2]) {
        const service = matchRoute[1];
        return `${service}/${matchRoute[2].replace(/\//g, '_')}`;
      }
    }
    return urlPath.replace(/\//g, '_');
  }

  private getMockRequestDelay() {
    const crypto = window.crypto;
    const arr = new Uint8Array(1);
    return (
      crypto.getRandomValues(arr)[0] *
      HttpMockInterceptorService.maxMockRequestDelay
    );
  }
}
